/**
 * Нормализация выделения: из набора выбрасываются ноды, чей предок тоже в наборе.
 *
 * Считают ОБЕ стороны. Клиент — чтобы оптимистично применить правильный результат;
 * сервер — потому что список может прислать агент руками, про правило не зная.
 * Полагаться на клиентскую нормализацию нельзя (ui-spec 3.2).
 */

/** Защита от испорченного дерева: цикла в `parent_id` быть не может, но приходить он может извне. */
const MAX_DEPTH = 10_000;

export function normalizeSelection(
	ids: readonly string[],
	parentOf: (id: string) => string | null | undefined
): string[] {
	const selected = new Set(ids);
	const out: string[] = [];
	const seenInResult = new Set<string>();

	for (const id of ids) {
		if (seenInResult.has(id)) {
			continue;
		}
		let cursor = parentOf(id);
		let hasSelectedAncestor = false;
		const visited = new Set<string>([id]);

		for (let depth = 0; cursor && depth < MAX_DEPTH; depth += 1) {
			if (visited.has(cursor)) {
				break; // цикл — дальше идти некуда
			}
			visited.add(cursor);
			if (selected.has(cursor)) {
				hasSelectedAncestor = true;
				break;
			}
			cursor = parentOf(cursor);
		}

		if (!hasSelectedAncestor) {
			seenInResult.add(id);
			out.push(id);
		}
	}

	return out;
}
